module.exports = __webpack_public_path__ + "static/img/3.e5446d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/3.png
// module id = WFsG
// module chunks = 13